module.exports = __webpack_public_path__ + "389501b67c29c6f3bc49831a92d3b4f7.png";